(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jj-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setUp(root) {
      const shirts = root.querySelector('[data-jj-sell-shirts]');
      const done = root.querySelector('[data-jj-sell-done]');
      if (done) root.scrollIntoView({ block: 'start' });
      if (!shirts || root.dataset.jjReady) return;
      root.dataset.jjReady = 'true';
      const submit = root.querySelector('[data-jj-sell-submit]');

      // Number the shirts and their field names, so each one arrives as "Shirt 2 - Season".
      const renumber = () => {
        const cards = [...shirts.querySelectorAll('[data-jj-sell-shirt]')];
        cards.forEach((card, index) => {
          const number = index + 1;
          card.querySelector('[data-jj-sell-shirt-title]').textContent = `Shirt ${number}`;
          card.querySelectorAll('[data-field]').forEach((field) => {
            field.name = `contact[Shirt ${number} - ${field.dataset.field}]`;
          });
          card.querySelector('[data-jj-sell-remove]').hidden = cards.length === 1;
        });
        if (submit) {
          submit.textContent =
            cards.length === 1 ? submit.dataset.one : submit.dataset.many.replace('[n]', String(cards.length));
        }
      };

      root.querySelector('[data-jj-sell-add]')?.addEventListener('click', () => {
        const copy = shirts.querySelector('[data-jj-sell-shirt]').cloneNode(true);
        copy.querySelectorAll('input').forEach((input) => (input.value = ''));
        copy.querySelectorAll('select').forEach((select) => (select.selectedIndex = 0));
        shirts.appendChild(copy);
        renumber();
        copy.querySelector('input')?.focus();
      });

      shirts.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-jj-sell-remove]') : null;
        if (!button) return;
        button.closest('[data-jj-sell-shirt]')?.remove();
        renumber();
      });

      renumber();
    }

    const run = () => document.querySelectorAll('[data-jj-sell]').forEach(setUp);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
